/* Little Big Supply kit builder (sections/lbs-builder.liquid).
   Vanilla custom element. Data comes from the section's embedded JSON. */
(function () {
  'use strict';
  if (customElements.get('lbs-builder')) return;

  var STEPS = [
    { key: 'car', label: 'Your car' },
    { key: 'lift', label: 'Lift' },
    { key: 'wheel', label: 'Wheels' },
    { key: 'tire', label: 'Tires' },
    { key: 'protection', label: 'Protection' },
    { key: 'extra', label: 'Finish' },
    { key: 'review', label: 'Review' }
  ];
  var DISCOUNT_STEPS = { adapter: 1, wheel: 1, tire: 1, protection: 1 };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function reducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function storageGet(key) {
    try { var raw = window.localStorage.getItem(key); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }
  function storageSet(key, val) {
    try { window.localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* private mode etc. */ }
  }
  function publish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* never break the builder over analytics */ }
  }
  function shortId() {
    var a = 'abcdefghjkmnpqrstuvwxyz23456789', s = '';
    for (var i = 0; i < 8; i++) s += a.charAt(Math.floor(Math.random() * a.length));
    return s;
  }
  // "Fuel Anza 15x7 Wheels 4x156 – Set of 4" -> "Fuel Anza 15x7 Wheels 4x156"
  function baseTitle(t) { return String(t || '').split(' – ')[0].split(' - Set of')[0].trim(); }
  function isDefaultVariant(v) { return !v || v.title === 'Default Title'; }
  // Tire sizes in a string -> normalized list, e.g. "BFG KO2 215/75R15" -> ["215/75R15"]
  function tireSizes(str) {
    var out = [], re = /(\d{3})\s*\/\s*(\d{2})\s*Z?R?\s*-?\s*(\d{2})(?!\d)/gi, m;
    str = String(str || '');
    while ((m = re.exec(str))) out.push(m[1] + '/' + m[2] + 'R' + m[3]);
    return out;
  }
  function hasSize(p, size) {
    var want = tireSizes(size)[0];
    if (!want) return false;
    return tireSizes(p.title + ' ' + (p.size || '')).indexOf(want) > -1;
  }

  class LbsBuilder extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var node = this.querySelector('[data-builder-json]');
      if (!node) return;
      try { this.d = JSON.parse(node.textContent); } catch (e) {
        console.error('[lbs-builder] bad data', e);
        return;
      }
      this.app = this.querySelector('[data-app]');
      this.panel = this.querySelector('[data-panel]');
      this.aside = this.querySelector('[data-aside]');
      this.bar = this.querySelector('[data-bar]');
      this.chips = this.querySelector('[data-chips]');
      this.progress = this.querySelector('[data-progress]');
      this.live = this.querySelector('[data-live]');
      this.t = this.d.t || {};
      this.pct = Number(this.d.percent) || 0;
      this.storeKey = 'lbsBuilder:' + this.d.vehicle;

      this.index();
      this.restore();

      var loading = this.querySelector('[data-loading]');
      if (loading) loading.remove();
      this.app.hidden = false;

      this.addEventListener('click', this.onClick.bind(this));
      this.watchVisibility();
      this.render(false);
      if (this.d.collection && this.d.collection.count > this.d.collection.paginated_items && this.d.collection.paginated_items) {
        console.warn('[lbs-builder] collection has more products than were paginated', this.d.collection);
      }
    }

    /* ---------- data ---------- */
    index() {
      var self = this;
      this.products = (this.d.products || []).filter(function (p) { return p && p.variants && p.variants.length; });
      this.byId = {};
      this.byVariant = {};
      this.products.forEach(function (p) {
        p.base = baseTitle(p.title);
        self.byId[p.id] = p;
        p.variants.forEach(function (v) { self.byVariant[v.id] = { p: p, v: v }; });
      });
      // products that share a base title (e.g. bumper bolts set of 2 / set of 4) are either/or
      var groups = {};
      this.products.forEach(function (p) {
        var k = p.step + '|' + p.base.toLowerCase();
        (groups[k] = groups[k] || []).push(p.id);
      });
      this.products.forEach(function (p) {
        var g = groups[p.step + '|' + p.base.toLowerCase()];
        p.group = g.length > 1 ? g : null;
        p.name = p.group ? p.title : p.base;
      });
      this.kit = this.products.filter(function (p) { return p.kit; })[0] || null;
      // Complete Full Send Kit (snippets/lbs-fsk.liquid)
      this.fsk = (this.d.fsk && this.d.fsk.kit) ? this.d.fsk : null;
      this.byHandle = {};
      this.products.forEach(function (p) { self.byHandle[p.handle] = p; });
      this.fskQty = {};
      this.fskKitSet = {};
      this.fskAddSet = {};
      this.fskTireSet = {};
      if (this.fsk) {
        this.fsk.kit.forEach(function (x) { self.fskKitSet[x.h] = 1; self.fskQty[x.h] = x.q || 1; });
        this.fsk.addons.forEach(function (x) { self.fskAddSet[x.h] = 1; self.fskQty[x.h] = x.q || 1; });
        (this.fsk.tires || []).forEach(function (h) { self.fskTireSet[h] = 1; });
      }
      this.adapter = this.of('adapter')[0] || null;
      this.cars = (this.d.cars && this.d.cars.length) ? this.d.cars : [{ handle: this.d.vehicle, name: this.d.vehicle, label: this.d.vehicle }];
    }
    of(step) {
      return this.products.filter(function (p) { return p.step === step && !p.kit; });
    }
    firstAvailable(p) {
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
      return null;
    }
    kitBuyable() { return !!(this.kit && this.firstAvailable(this.kit)); }
    car() {
      var h = this.s.car;
      return this.cars.filter(function (c) { return c.handle === h; })[0] || this.cars[0];
    }

    /* ---------- state ---------- */
    defaults() {
      var s = { step: 0, car: this.cars[0].handle, noKit: false, adapterOff: false, sel: {}, fsk: false };
      if (this.kitBuyable()) s.sel[this.kit.id] = this.firstAvailable(this.kit).id;
      else s.noKit = true;
      return s;
    }
    restore() {
      var s = this.defaults();
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
      var shared = params && params.get('build');
      var self = this;
      if (shared) {
        var sel = {};
        shared.split(',').forEach(function (raw) {
          var hit = self.byVariant[parseInt(raw, 10)];
          if (hit) sel[hit.p.id] = hit.v.id;
        });
        if (Object.keys(sel).length) {
          s.sel = sel;
          s.noKit = !(this.kit && sel[this.kit.id]);
          s.adapterOff = !!(this.selOf('wheel', sel).length && !(this.adapter && sel[this.adapter.id]));
          s.step = STEPS.length - 1;
          s.fsk = params.get('kit') === 'full-send';
          this.fromShare = true;
        }
        var car = params.get('car');
        if (car && this.cars.some(function (c) { return c.handle === car; })) s.car = car;
      } else {
        var saved = storageGet(this.storeKey);
        if (saved && typeof saved === 'object' && saved.sel) {
          var clean = {};
          Object.keys(saved.sel).forEach(function (pid) {
            var p = self.byId[pid];
            if (!p) return;
            var vid = saved.sel[pid];
            var ok = p.variants.some(function (v) { return v.id === vid && v.available; });
            var fallback = self.firstAvailable(p);
            if (ok) clean[pid] = vid;
            else if (fallback) clean[pid] = fallback.id;
          });
          s.sel = clean;
          s.noKit = !!saved.noKit || !this.kitBuyable();
          if (this.kit && s.noKit) delete clean[this.kit.id];
          if (!s.noKit && this.kit && !clean[this.kit.id]) clean[this.kit.id] = this.firstAvailable(this.kit).id;
          s.adapterOff = !!saved.adapterOff;
          s.fsk = !!saved.fsk && !!this.fsk;
          s.step = Math.max(0, Math.min(STEPS.length - 1, parseInt(saved.step, 10) || 0));
          if (saved.car && this.cars.some(function (c) { return c.handle === saved.car; })) s.car = saved.car;
        }
      }
      this.s = s;
      if (!shared && this.fsk && params && params.get('kit') === 'full-send') this.loadFullSend(true);
    }
    save() {
      storageSet(this.storeKey, { step: this.s.step, car: this.s.car, noKit: this.s.noKit, adapterOff: this.s.adapterOff, sel: this.s.sel, fsk: this.s.fsk });
    }

    /* ---------- Complete Full Send Kit ---------- */
    fskOn() { return !!(this.fsk && this.s.fsk); }
    fskEligible(p) { return !!(this.fsk && p && (p.step === 'wheel' || this.fskKitSet[p.handle] || this.fskAddSet[p.handle] || this.fskTireSet[p.handle])); }
    isAddon(p) { return !!(this.fsk && p && this.fskAddSet[p.handle]); }
    qtyOf(p) { return (this.fskOn() && p && this.fskQty[p.handle]) ? this.fskQty[p.handle] : 1; }
    fskTires() {
      var self = this;
      return this.of('tire').filter(function (p) { return self.fskTireSet[p.handle] && self.firstAvailable(p); });
    }
    fskDefaultTire() {
      var p = this.fsk ? this.byHandle[this.fsk.tireDefault] : null;
      if (p && this.firstAvailable(p)) return p;
      return this.fskTires()[0] || null;
    }
    fskMissing() {
      if (!this.fsk) return [];
      var self = this, out = [];
      this.fsk.kit.forEach(function (x) {
        var p = self.byHandle[x.h];
        if (p && self.firstAvailable(p) && !self.s.sel[p.id]) out.push(p);
      });
      return out;
    }
    fskEstimate() {
      // Kit price the way the cards on the site show it: kit parts + cheapest wheel + default tire
      if (!this.fsk) return null;
      var self = this, total = 0;
      this.fsk.kit.forEach(function (x) {
        var p = self.byHandle[x.h], v = p && self.firstAvailable(p);
        if (v) total += v.price * (x.q || 1);
      });
      var wheels = this.of('wheel').map(function (p) { var v = self.firstAvailable(p); return v ? v.price : 0; }).filter(Boolean);
      if (wheels.length) total += Math.min.apply(null, wheels);
      var tire = this.fskDefaultTire(), tv = tire && this.firstAvailable(tire);
      if (tv) total += tv.price;
      return { total: total, save: Math.round(total * this.fsk.pct / 100) };
    }
    loadFullSend(silent) {
      var f = this.fsk, self = this;
      if (!f) return;
      var old = this.s.sel, sel = {};
      f.kit.forEach(function (x) {
        var p = self.byHandle[x.h], v = p && self.firstAvailable(p);
        if (v) sel[p.id] = (old[p.id] && p.variants.some(function (z) { return z.id === old[p.id] && z.available; })) ? old[p.id] : v.id;
      });
      Object.keys(old).forEach(function (pid) {
        var p = self.byId[pid];
        if (p && (p.step === 'wheel' || self.fskAddSet[p.handle])) sel[pid] = old[pid];
      });
      var keepTire = this.selOf('tire', old).filter(function (p) { return self.fskTireSet[p.handle]; })[0];
      var tire = keepTire || this.fskDefaultTire();
      if (tire) sel[tire.id] = (keepTire && old[tire.id]) || this.firstAvailable(tire).id;
      this.s.sel = sel;
      this.s.fsk = true;
      this.s.noKit = !(this.kit && sel[this.kit.id]);
      this.s.adapterOff = false;
      this.s.step = this.selOf('wheel').length ? STEPS.length - 1 : 2;
      if (!silent) publish('lbs:fsk_load', { vehicle: this.d.vehicle, car: this.s.car, kit: f.key });
    }
    fskCard(where) {
      var f = this.fsk;
      if (!f) return '';
      var est = this.fskEstimate(), on = this.fskOn();
      var html = '<div class="lbsb-fsk' + (on ? ' is-on' : '') + '" role="region" aria-label="Complete Full Send Kit">';
      html += '<div class="lbsb-fsk__body"><p class="lbsb-fsk__kicker"><span class="lbs-badge lbs-badge--volt">Save ' + f.pct + '%</span> One tap, everything included</p>';
      html += '<p class="lbsb-fsk__title">Complete Full Send Kit</p>';
      html += '<p class="lbsb-fsk__sum">' + esc(f.summary) + '. You just pick the wheels' + (this.fskTires().length > 1 ? ' and tires' : '') + '.</p>';
      if (est && est.total) html += '<p class="lbsb-fsk__price"><span class="lbsb-fsk__was">' + this.money(est.total, true) + '</span> <strong>' + this.money(est.total - est.save, true) + '</strong> <span class="lbsb-fsk__from">kit price from, with ' + f.pct + '% off</span></p>';
      html += '</div><div class="lbsb-fsk__act">';
      if (on) html += '<p class="lbsb-fsk__on"><span aria-hidden="true">&#10003;</span> Kit loaded</p><button type="button" class="lbs-btn lbs-btn--ghost lbs-btn--sm" data-act="go" data-step="' + (this.has('wheel') ? STEPS.length - 1 : 2) + '" data-focus="fsk-' + where + '">' + (this.has('wheel') ? 'Review the kit' : 'Pick your wheels') + '</button>';
      else html += '<button type="button" class="lbs-btn lbs-btn--volt" data-act="fsk" data-focus="fsk-' + where + '">Load the Full Send Kit</button>';
      html += '</div></div>';
      return html;
    }
    selOf(step, sel) {
      sel = sel || this.s.sel;
      var self = this;
      return Object.keys(sel).map(function (pid) { return self.byId[pid]; }).filter(function (p) { return p && p.step === step && !p.kit; });
    }
    has(step) { return this.selOf(step).length > 0; }
    kitOn() { return !!(this.kit && this.s.sel[this.kit.id]); }
    lines() {
      var self = this, out = [];
      var order = ['lift', 'adapter', 'wheel', 'tire', 'protection', 'extra'];
      var ids = Object.keys(this.s.sel);
      order.forEach(function (step) {
        ids.forEach(function (pid) {
          var p = self.byId[pid];
          if (!p || p.step !== step) return;
          var v = p.variants.filter(function (x) { return x.id === self.s.sel[pid]; })[0] || p.variants[0];
          out.push({ p: p, v: v, q: self.qtyOf(p) });
        });
      });
      return out;
    }
    totals() {
      var self = this, lines = this.lines(), total = 0, matched = 0, savings = 0, kit = this.kitOn(), pct = this.pct, elig = 0;
      lines.forEach(function (l) {
        total += l.v.price * l.q;
        if (kit && l.p.discounted && DISCOUNT_STEPS[l.p.step]) {
          matched += l.v.price * l.q;
          savings += Math.round(l.v.price * l.q * pct / 100);
        }
        if (self.fskEligible(l.p)) elig += l.v.price * l.q;
      });
      var fskSave = 0, kind = savings > 0 ? 'build' : '';
      if (this.fsk && elig >= this.fsk.min) fskSave = Math.round(elig * this.fsk.pct / 100);
      if (fskSave >= savings && fskSave > 0) { savings = fskSave; kind = 'fsk'; }
      var units = 0;
      lines.forEach(function (l) { units += l.q; });
      return { lines: lines, total: total, matched: matched, savings: savings, kind: kind, count: units, elig: elig, toGo: this.fsk ? Math.max(0, this.fsk.min - elig) : 0 };
    }

    /* ---------- money ---------- */
    money(cents, keepZeros) {
      cents = Math.round(Number(cents) || 0);
      var fmt = this.d.money_format || '${{amount}}';
      var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      var trim = cents % 100 === 0;
      function group(n, dec, thou, sep) {
        var fixed = (n / 100).toFixed(dec);
        var parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return parts[1] ? parts[0] + sep + parts[1] : parts[0];
      }
      if (!m) {
        try {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: trim ? 0 : 2, maximumFractionDigits: trim ? 0 : 2 }).format(cents / 100);
        } catch (e) { return '$' + group(cents, trim ? 0 : 2, ',', '.'); }
      }
      var val;
      switch (m[1]) {
        case 'amount_no_decimals': val = group(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': val = group(cents, trim ? 0 : 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = group(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': val = group(cents, trim ? 0 : 2, "'", '.'); break;
        default: val = group(cents, trim ? 0 : 2, ',', '.');
      }
      return fmt.replace(m[0], val).replace(/\s*USD\s*$/, '').trim();
    }

    /* ---------- small view helpers ---------- */
    stock(v, p) {
      if (v.inventory_management) {
        if (v.inventory_quantity > 0) return { cls: 'ok', text: 'In stock · ships same day' };
        if (v.inventory_policy === 'continue') return { cls: 'back', text: (p && p.ships_note) || 'Backordered' };
        return { cls: 'out', text: 'Sold out' };
      }
      if (!v.available) return { cls: 'out', text: 'Sold out' };
      return { cls: 'ok', text: 'Ships same day' };
    }
    pill(v, p) {
      var s = this.stock(v, p);
      return '<span class="lbsb-pill lbsb-pill--' + s.cls + '">' + esc(s.text) + '</span>';
    }
    stars(p) {
      var r = Number(p.rating) || 0;
      if (r <= 0) return '';
      var rr = Math.round(r * 100) / 100;
      var pct = Math.round(r / 5 * 1000) / 10;
      return '<span class="lbs-stars lbsb-stars"><span class="lbs-stars__row" style="--pct:' + pct + '%" role="img" aria-label="Rated ' + rr + ' out of 5"></span>' +
        '<span class="lbs-stars__text">' + rr + (p.count > 0 ? ' · ' + p.count + ' reviews' : '') + '</span></span>';
    }
    img(src, alt, cls) {
      if (!src) return '<span class="lbsb-noimg ' + (cls || '') + '" aria-hidden="true"></span>';
      return '<img class="' + (cls || '') + '" src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="lazy" decoding="async" width="600" height="600">';
    }
    selVariant(p) {
      var vid = this.s.sel[p.id];
      return p.variants.filter(function (v) { return v.id === vid; })[0] || null;
    }
    shownVariant(p) {
      return this.selVariant(p) || this.firstAvailable(p) || p.variants[0];
    }
    variantButtons(p, label) {
      if (p.variants.length < 2) return '';
      var sel = this.s.sel[p.id];
      var html = '<div class="lbsb-variants" role="group" aria-label="' + esc((p.option || 'Option') + ' for ' + p.name) + '">';
      p.variants.forEach(function (v) {
        var on = sel === v.id;
        html += '<button type="button" class="lbsb-variant' + (on ? ' is-on' : '') + '" data-act="variant" data-pid="' + p.id + '" data-vid="' + v.id + '" data-focus="v' + v.id + '" aria-pressed="' + on + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' <small>sold out</small>') + '</button>';
      });
      return html + '</div>';
    }

    /* ---------- render ---------- */
    render(stepChanged) {
      var active = document.activeElement;
      var focusKey = active && this.contains(active) ? active.getAttribute('data-focus') : null;
      this.renderChips();
      this.panel.innerHTML = this.renderStep();
      this.renderSummary();
      this.watchPrimary();
      this.save();
      if (stepChanged) {
        var h = this.panel.querySelector('[data-step-heading]');
        var top = this.querySelector('.lbsb__nav');
        if (top && top.getBoundingClientRect().top < 0) {
          top.scrollIntoView({ block: 'start', behavior: reducedMotion() ? 'auto' : 'smooth' });
        }
        if (h) h.focus({ preventScroll: true });
      } else if (focusKey) {
        var el = this.querySelector('[data-focus="' + focusKey + '"]');
        if (el && !el.disabled) el.focus({ preventScroll: true });
      }
    }
    renderChips() {
      var self = this, html = '';
      STEPS.forEach(function (st, i) {
        var cur = i === self.s.step;
        var done = i < self.s.step;
        html += '<li><button type="button" class="lbsb-chip' + (cur ? ' is-current' : '') + (done ? ' is-done' : '') + '" data-act="go" data-step="' + i + '" data-focus="chip' + i + '"' + (cur ? ' aria-current="step"' : '') + '>' +
          '<span class="lbsb-chip__n" aria-hidden="true">' + (done ? '&#10003;' : (i + 1)) + '</span><span>' + esc(st.label) + '</span>' +
          (done ? '<span class="visually-hidden-lbs"> (done)</span>' : '') + '</button></li>';
      });
      this.chips.innerHTML = html;
      if (this.progress) this.progress.style.width = Math.round(this.s.step / (STEPS.length - 1) * 100) + '%';
      var curChip = this.chips.querySelector('.is-current');
      if (curChip && this.chips.scrollWidth > this.chips.clientWidth) {
        var left = curChip.offsetLeft - (this.chips.clientWidth - curChip.offsetWidth) / 2;
        try { this.chips.scrollTo({ left: Math.max(0, left), behavior: reducedMotion() ? 'auto' : 'smooth' }); } catch (e) { this.chips.scrollLeft = left; }
      }
    }
    head(i, title, sub) {
      return '<div class="lbsb-step__head"><span class="lbsb-step__num" aria-hidden="true">' + String(i + 1).padStart(2, '0') + '</span><div>' +
        '<p class="lbsb-step__of">Step ' + (i + 1) + ' of ' + STEPS.length + '</p>' +
        '<h3 class="lbsb-step__title" tabindex="-1" data-step-heading>' + esc(title) + '</h3>' +
        (sub ? '<p class="lbsb-step__sub">' + sub + '</p>' : '') + '</div></div>';
    }
    renderStep() {
      switch (STEPS[this.s.step].key) {
        case 'car': return this.stepCar();
        case 'lift': return this.stepLift();
        case 'wheel': return this.stepWheels();
        case 'tire': return this.stepTires();
        case 'protection': return this.stepProtection();
        case 'extra': return this.stepExtras();
        default: return this.stepReview();
      }
    }

    stepCar() {
      var c = this.car(), self = this;
      var html = this.head(0, 'Your car', 'Every part in this builder is matched to your car.');
      html += this.fskCard('car');
      html += '<div class="lbsb-car">';
      html += '<div class="lbsb-car__media">' + this.img(c.image, c.name, '') + (c.lift ? '<span class="lbs-vehicle__lift">' + esc(String(c.lift).replace('Nearly ', '')) + '<small>Lift</small></span>' : '') + '</div>';
      html += '<div class="lbsb-car__body"><span class="lbs-badge lbs-badge--ink">Pinned</span>';
      html += '<p class="lbsb-car__name">' + esc(c.name) + '</p>';
      if (c.years) html += '<p class="lbsb-car__years">' + esc(c.years) + '</p>';
      if (this.cars.length > 1) {
        html += '<p class="lbsb-car__pick" id="lbsb-carpick-' + this.dataset.section + '">Same platform, same parts. Pick yours:</p><div class="lbsb-car__chips" role="group" aria-labelledby="lbsb-carpick-' + this.dataset.section + '">';
        this.cars.forEach(function (x) {
          var on = x.handle === self.s.car;
          html += '<button type="button" class="lbs-chip lbsb-carchip' + (on ? ' is-active' : '') + '" aria-pressed="' + on + '" data-act="car" data-car="' + esc(x.handle) + '" data-focus="car-' + esc(x.handle) + '">' + esc(x.label || x.short || x.name) + '</button>';
        });
        html += '</div>';
      }
      html += '<ul class="lbsb-facts">';
      if (this.t.savings_rule) html += '<li>' + esc(this.t.savings_rule) + '</li>';
      if (this.t.shipping) html += '<li>' + esc(this.t.shipping) + '</li>';
      if (this.t.installments) html += '<li>' + esc(this.t.installments) + '</li>';
      html += '</ul>';
      if (this.t.change_url) html += '<a class="lbs-link lbsb-car__change" href="' + esc(this.t.change_url) + '">Different car? Change vehicle</a>';
      html += '</div></div>';
      html += this.stepNav();
      return html;
    }

    stepLift() {
      var k = this.kit, on = this.kitOn();
      var html = this.head(1, 'Start with the lift', 'The kit is the heart of the build, and the key to build savings.');
      html += this.fskCard('lift');
      if (!k) {
        html += '<p class="lbs-callout">We couldn\'t load the lift kit for this car. <a class="lbs-link" href="' + esc(this.t.help_url) + '">Ask us</a> and we\'ll sort it out.</p>';
        return html + this.stepNav();
      }
      var v = this.shownVariant(k);
      var buyable = this.kitBuyable();
      html += '<article class="lbsb-kit' + (on ? ' is-on' : '') + '">';
      html += '<div class="lbsb-kit__media">' + this.img(v.image || k.image, k.title, '') + (on ? '<span class="lbsb-check" aria-hidden="true">&#10003;</span>' : '') + '</div>';
      html += '<div class="lbsb-kit__body">';
      html += '<span class="lbs-badge lbs-badge--volt">' + (on ? 'In your build' : (buyable ? 'Recommended' : 'Back soon')) + '</span>';
      html += '<h4 class="lbsb-kit__title"><a href="' + esc(k.url) + '" target="_blank" rel="noopener">' + esc(k.title) + '<span class="visually-hidden-lbs"> (opens in a new tab)</span></a></h4>';
      html += this.stars(k);
      html += '<p class="lbsb-price">' + this.money(v.price) + '</p>';
      html += buyable ? this.pill(v, k) : '<span class="lbsb-pill lbsb-pill--back">' + esc(this.t.kit_soon || 'Back in stock soon') + '</span>';
      html += this.variantButtons(k);
      html += '<div class="lbsb-kit__actions">';
      if (on) {
        html += '<button type="button" class="lbs-btn lbs-btn--ghost lbsb-btn" data-act="nokit" data-focus="nokit">I already have a lift</button>';
      } else if (buyable) {
        html += '<button type="button" class="lbs-btn lbs-btn--volt lbsb-btn" data-act="kit" data-focus="kit">Add the lift kit</button>';
      }
      html += '</div></div></article>';
      if (!buyable) {
        html += '<div class="lbsb-note lbsb-note--info" role="note"><strong>' + esc(this.t.kit_soon || 'Back in stock soon') + '.</strong> ' + esc(this.t.kit_soon_text || '') +
          ' <a class="lbs-link" href="' + esc(k.url) + '">See the kit</a></div>';
      } else if (!on) {
        html += '<div class="lbsb-note lbsb-note--warn" role="note"><strong>No kit, no build savings.</strong> Build savings apply when the lift kit is in the same order. You can still build the rest at regular prices.</div>';
      }
      return html + this.stepNav();
    }

    tile(p, opts) {
      opts = opts || {};
      var on = !!this.s.sel[p.id];
      var v = this.shownVariant(p);
      var buyable = !!this.firstAvailable(p);
      var html = '<article class="lbsb-tile' + (on ? ' is-on' : '') + (opts.cls ? ' ' + opts.cls : '') + '">';
      html += '<button type="button" class="lbsb-tile__pick" data-act="' + (opts.act || 'toggle') + '" data-pid="' + p.id + '" data-focus="p' + p.id + '" aria-pressed="' + on + '"' + (buyable ? '' : ' disabled') + '>';
      html += '<span class="lbsb-tile__media">' + this.img(v.image || p.image, '', '') + (opts.badge ? '<span class="lbs-badge lbs-badge--volt lbsb-tile__badge">' + esc(opts.badge) + '</span>' : '') + '<span class="lbsb-check" aria-hidden="true">&#10003;</span></span>';
      html += '<span class="lbsb-tile__body"><span class="lbsb-tile__title">' + esc(opts.title || p.name) + '</span>';
      html += '<span class="lbsb-tile__price">' + this.money(v.price) + (opts.unit ? ' <small>' + esc(opts.unit) + '</small>' : '') + '</span>';
      if (opts.flag) html += '<span class="lbsb-tile__flag">' + esc(opts.flag) + '</span>';
      html += '<span class="lbsb-tile__cta">' + (on ? (opts.onLabel || 'Selected') : (opts.offLabel || 'Select')) + '</span>';
      html += '</span></button>';
      var st = this.stock(v, p);
      if (st.cls === 'back') html += '<p class="lbsb-tile__ship">' + esc(st.text) + '</p>';
      if (opts.note) html += '<p class="lbsb-tile__note' + (opts.noteCls ? ' ' + opts.noteCls : '') + '">' + esc(opts.note) + '</p>';
      if (opts.stars) html += '<div class="lbsb-tile__stars">' + this.stars(p) + '</div>';
      html += this.variantButtons(p);
      html += '<a class="lbsb-tile__link" href="' + esc(p.url) + '" target="_blank" rel="noopener">Details<span class="visually-hidden-lbs"> for ' + esc(p.name) + ' (opens in a new tab)</span></a>';
      html += '</article>';
      return html;
    }

    stepWheels() {
      var self = this, wheels = this.of('wheel');
      var html = this.head(2, 'Pick your wheels', 'Sold as a set of 4. One set per build.');
      if (this.fskOn()) html += '<div class="lbsb-note lbsb-note--info" role="note"><strong>Full Send Kit loaded.</strong> Pick your wheels. The lift, adapters and the rest of the kit are already in your build.</div>';
      if (!wheels.length) {
        html += '<p class="lbsb-empty">No wheels listed for this car right now.</p>';
      } else {
        html += '<div class="lbsb-grid lbsb-grid--wheels">';
        wheels.forEach(function (p) {
          html += self.tile(p, { act: 'wheel', unit: 'set of 4', onLabel: 'Selected', offLabel: 'Choose' });
        });
        html += '</div>';
      }
      html += this.adapterBlock();
      html += '<div class="lbsb-skip"><button type="button" class="lbs-btn lbs-btn--ghost lbs-btn--sm" data-act="skip" data-step-key="wheel" data-focus="skipwheel">' + (this.has('wheel') ? 'Remove wheels' : 'I have wheels, skip') + '</button></div>';
      return html + this.stepNav();
    }
    adapterBlock() {
      var a = this.adapter;
      if (!a) return '';
      var on = !!this.s.sel[a.id];
      var hasWheels = this.has('wheel');
      if (!hasWheels && !on) return '';
      var v = this.shownVariant(a);
      var html = '<div class="lbsb-adapter' + (on ? ' is-on' : ' is-off') + '" role="region" aria-label="Wheel adapters">';
      html += '<div class="lbsb-adapter__media">' + this.img(v.image || a.image, '', '') + '</div>';
      html += '<div class="lbsb-adapter__body"><p class="lbsb-adapter__kicker">' + (on ? 'Added with your wheels' : 'Adapters removed') + '</p>';
      html += '<p class="lbsb-adapter__title">' + esc(a.name) + ' <span class="lbsb-adapter__price">' + this.money(v.price) + '</span></p>';
      if (this.t.adapter_why) html += '<p class="lbsb-adapter__why">' + esc(this.t.adapter_why) + '</p>';
      if (!on) html += '<p class="lbsb-adapter__warn" role="alert">Heads up: without adapters, 4x156 wheels won\'t bolt to your car\'s factory hubs. Only skip them if you already have a set.</p>';
      html += this.pill(v, a);
      html += '</div><div class="lbsb-adapter__act">';
      if (on) html += '<button type="button" class="lbs-btn lbs-btn--ghost lbs-btn--sm" data-act="adapter-off" data-focus="adapter">I have adapters, remove</button>';
      else if (this.firstAvailable(a)) html += '<button type="button" class="lbs-btn lbs-btn--volt lbs-btn--sm" data-act="adapter-on" data-focus="adapter">Add adapters back</button>';
      html += '</div></div>';
      return html;
    }

    stepTires() {
      var self = this;
      var tires = this.of('tire').slice().sort(function (a, b) {
        return self.shownVariant(a).price - self.shownVariant(b).price;
      });
      var n = tires.length;
      var html = this.head(3, 'Pick your tires', 'Sold as a set of 4. Sorted by price.');
      if (!n) {
        html += '<p class="lbsb-empty">No tires listed for this car right now.</p>';
      } else {
        html += '<div class="lbsb-grid lbsb-grid--tires">';
        var kitOn = this.kitOn(), t = this.t;
        tires.forEach(function (p, i) {
          var tier = n < 3 ? '' : (i < n / 3 ? 'Good' : (i < 2 * n / 3 ? 'Better' : 'Best'));
          var o = { act: 'tire', badge: tier, unit: 'set of 4', stars: true, offLabel: 'Choose', cls: 'lbsb-tile--wide' };
          if (self.fskOn() && self.fsk.tireDefault === p.handle) o.badge = 'Kit pick';
          if (t.lift_tire_size && hasSize(p, t.lift_tire_size)) {
            o.flag = t.lift_tire_flag || 'Needs the lift kit';
            if (!kitOn && t.lift_tire_note) { o.note = t.lift_tire_note; o.noteCls = 'lbsb-tile__note--warn'; }
          } else if (t.tire_fit_size && t.tire_fit_note && hasSize(p, t.tire_fit_size)) {
            o.note = t.tire_fit_note;
          }
          if (self.fsk && self.fsk.tireAlt === p.handle && self.fsk.tireAltNote) { o.note = self.fsk.tireAltNote; o.noteCls = ''; }
          html += self.tile(p, o);
        });
        html += '</div>';
      }
      html += '<div class="lbsb-skip"><button type="button" class="lbs-btn lbs-btn--ghost lbs-btn--sm" data-act="skip" data-step-key="tire" data-focus="skiptire">' + (this.has('tire') ? 'Remove tires' : 'Skip tires') + '</button></div>';
      return html + this.stepNav();
    }

    stepProtection() {
      var self = this;
      var items = this.of('protection');
      var flares = items.filter(function (p) { return /flare/i.test(p.title); });
      var rest = items.filter(function (p) { return flares.indexOf(p) < 0; });
      var html = this.head(4, 'Armor up', 'Optional. Tap to add. Matched parts count toward build savings.');
      if (!items.length) html += '<p class="lbsb-empty">No armor listed for this car right now.</p>';
      if (flares.length) {
        html += '<div class="lbsb-grid lbsb-grid--feature">';
        flares.forEach(function (p) {
          html += self.tile(p, { badge: 'Recommended', note: self.t.flare_note, offLabel: 'Add', onLabel: 'Added', cls: 'lbsb-tile--wide', stars: true });
        });
        html += '</div>';
      }
      if (rest.length) {
        html += '<div class="lbsb-grid lbsb-grid--tiles">';
        rest.forEach(function (p) {
          html += self.tile(p, { offLabel: 'Add', onLabel: 'Added', note: self.isAddon(p) ? 'Full Send add-on: 10% off with the kit' : (p.group ? 'Pick one size' : '') });
        });
        html += '</div>';
      }
      return html + this.stepNav();
    }

    stepExtras() {
      var self = this;
      var items = this.of('extra');
      var wheelsOn = this.has('wheel') || this.has('adapter');
      var forgot = wheelsOn ? items.filter(function (p) { return /lug nut|tpms/i.test(p.title); }) : [];
      forgot.sort(function (a, b) { return (/lug nut/i.test(a.title) ? 0 : 1) - (/lug nut/i.test(b.title) ? 0 : 1); });
      var rest = items.filter(function (p) { return forgot.indexOf(p) < 0; });
      var html = this.head(5, 'Finish the build', this.fsk ? 'Extras are optional. Full Send add-ons get 10% off when your kit is complete.' : 'Extras are optional and aren\'t part of build savings.');
      if (forgot.length) {
        html += '<div class="lbsb-forgot"><p class="lbsb-forgot__title">' + esc(this.t.lug_note || 'Most forgotten part: lug nuts') + '</p>';
        html += '<p class="lbsb-forgot__sub">New wheels and adapters usually need these.</p><div class="lbsb-grid lbsb-grid--tiles">';
        forgot.forEach(function (p) { html += self.tile(p, { offLabel: 'Add', onLabel: 'Added', title: p.name }); });
        html += '</div></div>';
      }
      if (rest.length) {
        html += '<div class="lbsb-grid lbsb-grid--tiles">';
        rest.forEach(function (p) {
          var rack = /roof rack/i.test(p.title);
          var q = self.fskQty[p.handle] > 1 && self.isAddon(p) ? ' (kit adds ' + self.fskQty[p.handle] + ')' : '';
          html += self.tile(p, { offLabel: 'Add', onLabel: 'Added', note: self.isAddon(p) ? 'Full Send add-on: 10% off with the kit' + q : (rack ? 'Not part of build savings' : '') });
        });
        html += '</div>';
      }
      if (!items.length) html += '<p class="lbsb-empty">No extras listed for this car right now.</p>';
      return html + this.stepNav();
    }

    stepReview() {
      var self = this, t = this.totals(), kit = this.kitOn();
      var html = this.head(6, 'Review your build', this.fromShare ? 'Loaded from a shared link. Check it over, then add it to your cart.' : 'Check it over, then add the whole build to your cart in one tap.');
      if (!t.count) {
        html += '<p class="lbsb-empty">Your build is empty. <button type="button" class="lbs-link lbsb-linkbtn" data-act="go" data-step="1">Start with the lift</button>.</p>';
        return html + this.stepNav();
      }
      if (!kit && this.kit) {
        html += '<div class="lbsb-note lbsb-note--warn" role="note"><strong>No lift kit in this build.</strong> Build savings need the kit in the same order. ' +
          (this.kitBuyable() ? '<button type="button" class="lbs-link lbsb-linkbtn" data-act="kit" data-focus="kit-review">Add the kit</button>' : esc((this.t.kit_soon || 'Back in stock soon') + ' for the kit.')) + '</div>';
      }
      if (this.fsk) html += this.fskStatus(t);
      var tt = this.t;
      if (!kit && tt.lift_tire_size && tt.lift_tire_note && this.selOf('tire').some(function (p) { return hasSize(p, tt.lift_tire_size); })) {
        html += '<div class="lbsb-note lbsb-note--warn" role="note"><strong>' + esc(tt.lift_tire_flag || 'Needs the lift kit') + '.</strong> ' + esc(tt.lift_tire_note) + '.</div>';
      }
      var blocked = false;
      html += '<ul class="lbsb-lines">';
      t.lines.forEach(function (l) {
        var st = self.stock(l.v, l.p);
        if (st.cls === 'out') blocked = true;
        var disc = t.kind === 'fsk' ? self.fskEligible(l.p) : (kit && l.p.discounted && DISCOUNT_STEPS[l.p.step]);
        html += '<li class="lbsb-line' + (st.cls === 'out' ? ' is-out' : '') + '">';
        html += '<span class="lbsb-line__media">' + self.img(l.v.image || l.p.image, '', '') + '</span>';
        html += '<span class="lbsb-line__info"><a class="lbsb-line__title" href="' + esc(l.p.url) + '" target="_blank" rel="noopener">' + esc(l.p.name) + '</a>';
        if (!isDefaultVariant(l.v)) html += '<span class="lbsb-line__variant">' + esc(l.v.title) + '</span>';
        html += '<span class="lbsb-line__meta">' + self.pill(l.v, l.p) + (disc ? '<span class="lbsb-pill lbsb-pill--save">' + (t.kind === 'fsk' ? 'Full Send Kit 10%' : 'Build savings') + '</span>' : '') + '</span></span>';
        html += '<span class="lbsb-line__right"><span class="lbsb-line__price">' + (l.q > 1 ? l.q + ' &times; ' : '') + self.money(l.v.price) + '</span>';
        html += '<button type="button" class="lbsb-line__remove" data-act="remove" data-pid="' + l.p.id + '" data-focus="rm' + l.p.id + '">Remove<span class="visually-hidden-lbs"> ' + esc(l.p.name) + '</span></button></span>';
        html += '</li>';
      });
      html += '</ul>';
      html += '<div class="lbsb-totals">';
      if (t.savings > 0) html += '<p class="lbsb-totals__save">You save about ' + this.money(t.savings, true) + (t.kind === 'fsk' ? ' with the Full Send Kit' : ' with build savings') + '</p>';
      html += '<p class="lbsb-totals__line"><span>Shipping (lower 48)</span><span>Free</span></p>';
      html += '<p class="lbsb-totals__row"><span>Total</span><strong>' + this.money(t.total, true) + '</strong></p>';
      if (t.savings > 0) html += '<p class="lbsb-totals__line lbsb-totals__line--after"><span>Est. after ' + (t.kind === 'fsk' ? 'kit savings' : 'build savings') + '</span><span>' + this.money(t.total - t.savings, true) + '</span></p>';
      html += '<p class="lbsb-totals__fine">' + (t.savings > 0 ? (t.kind === 'fsk' ? 'The Full Send Kit 10% is applied automatically at checkout. ' : 'Build savings are applied automatically at checkout. ') : '') + 'Taxes calculated at checkout.</p>';
      if (this.t.installments) html += '<p class="lbsb-totals__fine">' + esc(this.t.installments) + '</p>';
      html += '</div>';
      if (blocked) html += '<div class="lbsb-note lbsb-note--crit" role="note">Part of this build is sold out. Remove it to add the rest to your cart.</div>';
      html += '<div class="lbsb-msg" data-msg role="status">' + (this.msg || '') + '</div>';
      html += '<div class="lbsb-actions">';
      html += '<button type="button" class="lbs-btn lbs-btn--volt lbs-btn--block lbsb-add" data-act="add" data-focus="add"' + (this.busy ? ' aria-busy="true" disabled' : '') + '>' + (this.busy ? 'Adding&hellip;' : 'Add build to cart &middot; ' + this.money(t.total, true)) + '</button>';
      html += '<div class="lbsb-actions__row"><button type="button" class="lbs-btn lbs-btn--ghost" data-act="share" data-focus="share">Copy share link</button>';
      html += '<a class="lbs-btn lbs-btn--ghost" href="' + esc(this.t.help_url || '/pages/contact') + '">' + esc(this.t.help_label || 'Ask a build expert') + '</a></div>';
      html += '</div>';
      if (this.t.shipping) html += '<p class="lbsb-ship">' + esc(this.t.shipping) + '</p>';
      return html;
    }

    fskStatus(t) {
      var f = this.fsk, self = this;
      if (!f) return '';
      var missing = this.fskMissing();
      var hasW = this.has('wheel'), hasT = this.selOf('tire').some(function (p) { return self.fskTireSet[p.handle]; });
      if (t.kind === 'fsk') {
        return '<div class="lbsb-note lbsb-note--ok lbsb-fsknote" role="note"><strong>Complete Full Send Kit: ' + f.pct + '% off.</strong> About ' + this.money(t.savings, true) + ' comes off at checkout' + (t.kind === 'fsk' && missing.length ? '. Tip: the kit also includes ' + missing.map(function (p) { return esc(p.name); }).join(', ') : '') + '.</div>';
      }
      if (!this.fskOn() && t.elig < f.min / 2) {
        return '<div class="lbsb-note lbsb-note--info lbsb-fsknote" role="note"><strong>Want it all?</strong> Load the Complete Full Send Kit and save ' + f.pct + '%. <button type="button" class="lbs-link lbsb-linkbtn" data-act="fsk" data-focus="fsk-review">Load the kit</button></div>';
      }
      var html = '<div class="lbsb-note lbsb-note--info lbsb-fsknote" role="note"><strong>' + this.money(t.toGo, true) + ' to go for the Full Send Kit ' + f.pct + '%.</strong> ';
      var bits = [];
      if (!hasW) bits.push('<button type="button" class="lbs-link lbsb-linkbtn" data-act="go" data-step="2">pick your wheels</button>');
      if (!hasT) bits.push('<button type="button" class="lbs-link lbsb-linkbtn" data-act="go" data-step="3">pick your tires</button>');
      missing.forEach(function (p) { bits.push('<button type="button" class="lbs-link lbsb-linkbtn" data-act="fsk-add" data-pid="' + p.id + '" data-focus="fska' + p.id + '">add ' + esc(p.name) + '</button>'); });
      if (bits.length) html += 'To finish the kit: ' + bits.join(', ') + '.';
      else html += 'Add a Full Send add-on to get there.';
      return html + '</div>';
    }

    stepNav() {
      // In-panel nav (visible on all sizes; the sticky bar mirrors it on phones)
      var i = this.s.step, last = STEPS.length - 1;
      var html = '<div class="lbsb-stepnav">';
      if (i > 0) html += '<button type="button" class="lbs-btn lbs-btn--ghost" data-act="back" data-focus="back-in">Back</button>';
      if (i < last) html += '<button type="button" class="lbs-btn lbs-btn--ink" data-act="next" data-focus="next-in">Next: ' + esc(STEPS[i + 1].label) + '</button>';
      return html + '</div>';
    }

    renderSummary() {
      var self = this, t = this.totals(), i = this.s.step, last = STEPS.length - 1;
      var nextLabel = i < last ? 'Next: ' + STEPS[i + 1].label : (this.busy ? 'Adding…' : 'Add build to cart');
      // desktop aside
      var html = '<div class="lbsb-sum"><p class="lbsb-sum__title">Your build</p>';
      var c = this.car();
      html += '<p class="lbsb-sum__car">' + esc(c.label && this.cars.length > 1 ? c.label : (c.short || c.name)) + '</p>';
      if (!t.count) html += '<p class="lbsb-sum__empty">Nothing yet. Start with the lift.</p>';
      else {
        html += '<ul class="lbsb-sum__list">';
        t.lines.forEach(function (l) {
          html += '<li><span>' + (l.q > 1 ? l.q + ' &times; ' : '') + esc(l.p.name) + (isDefaultVariant(l.v) ? '' : ' <small>' + esc(l.v.title) + '</small>') + '</span><span>' + self.money(l.v.price * l.q) + '</span></li>';
        });
        html += '</ul>';
      }
      html += '<p class="lbsb-sum__total"><span>Total</span><strong>' + this.money(t.total, true) + '</strong></p>';
      if (t.savings > 0) html += '<p class="lbsb-sum__save">You save about ' + this.money(t.savings, true) + (t.kind === 'fsk' ? ' with the Full Send Kit' : '') + '</p>';
      if (this.fskOn() && t.kind !== 'fsk' && t.toGo > 0) html += '<p class="lbsb-sum__hint">' + this.money(t.toGo, true) + ' more in kit parts unlocks 10% off.</p>';
      else if (this.kit && !this.kitBuyable()) html += '<p class="lbsb-sum__hint">Lift kit: ' + esc((this.t.kit_soon || 'Back in stock soon').toLowerCase()) + '.</p>';
      else if (this.kit && !this.kitOn()) html += '<p class="lbsb-sum__hint">Add the lift kit to unlock build savings.</p>';
      else if (this.kitOn()) html += '<p class="lbsb-sum__hint">' + esc(this.t.savings_rule || '') + '</p>';
      if (this.applied) html += '<p class="lbsb-sum__save">' + esc(this.applied) + '</p>';
      html += '<div class="lbsb-sum__nav">';
      if (i > 0) html += '<button type="button" class="lbs-btn lbs-btn--ghost" data-act="back" data-focus="back-aside">Back</button>';
      html += '<button type="button" class="lbs-btn lbs-btn--volt" data-act="' + (i < last ? 'next' : 'add') + '" data-focus="next-aside"' + (this.busy ? ' disabled' : '') + '>' + esc(nextLabel) + '</button>';
      html += '</div></div>';
      this.aside.innerHTML = html;

      // mobile sticky bar
      var bar = '<div class="lbsb-bar__info"><span class="lbsb-bar__label">' + t.count + (t.count === 1 ? ' part' : ' parts') + ' · Total</span><strong class="lbsb-bar__total">' + this.money(t.total, true) + '</strong>' +
        (t.savings > 0 ? '<span class="lbsb-bar__save">Save about ' + this.money(t.savings, true) + '</span>' : '') + '</div>';
      bar += '<div class="lbsb-bar__btns">';
      if (i > 0) bar += '<button type="button" class="lbsb-bar__back" data-act="back" data-focus="back-bar" aria-label="Back to ' + esc(STEPS[i - 1].label) + '"><span aria-hidden="true">&larr;</span></button>';
      bar += '<button type="button" class="lbs-btn lbs-btn--volt lbsb-bar__next" data-act="' + (i < last ? 'next' : 'add') + '" data-focus="next-bar"' + (this.busy ? ' disabled' : '') + '>' + esc(i < last ? 'Next' : (this.busy ? 'Adding…' : 'Add to cart')) + (i < last ? ' <span aria-hidden="true">&rarr;</span>' : '') + '</button>';
      bar += '</div>';
      this.bar.innerHTML = bar;

      var liveText = 'Build total ' + this.money(t.total, true) + (t.savings > 0 ? ', you save about ' + this.money(t.savings, true) : '');
      if (this._lastLive !== liveText) {
        this._lastLive = liveText;
        if (this._liveTimer) clearTimeout(this._liveTimer);
        var live = this.live;
        this._liveTimer = setTimeout(function () { live.textContent = liveText; }, 400);
      }
    }

    // Phones: hide the sticky bar while the step's own primary button (Next / Add build to cart) is on screen,
    // so the bar never sits on top of it.
    watchPrimary() {
      if (!('IntersectionObserver' in window)) return;
      var self = this;
      if (!this._pio) {
        this._pio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { self.classList.toggle('is-primary-visible', e.isIntersecting); });
        });
      }
      this._pio.disconnect();
      var btn = this.panel.querySelector('.lbsb-add, .lbsb-stepnav [data-act="next"]');
      if (btn) this._pio.observe(btn);
      else this.classList.remove('is-primary-visible');
    }

    watchVisibility() {
      var self = this;
      if (!('IntersectionObserver' in window)) { this.classList.add('is-inview'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { self.classList.toggle('is-inview', e.isIntersecting); });
      }, { rootMargin: '0px 0px -30% 0px' });
      io.observe(this.querySelector('.lbsb__layout') || this);
    }

    /* ---------- actions ---------- */
    onClick(e) {
      var btn = e.target.closest('[data-act]');
      if (!btn || !this.contains(btn) || btn.disabled) return;
      var act = btn.getAttribute('data-act');
      var pid = btn.getAttribute('data-pid');
      var p = pid ? this.byId[pid] : null;
      this.msg = this.msg && act !== 'share' && act !== 'add' ? '' : this.msg;
      switch (act) {
        case 'go': this.goTo(parseInt(btn.getAttribute('data-step'), 10)); return;
        case 'next': this.goTo(this.s.step + 1); return;
        case 'back': this.goTo(this.s.step - 1); return;
        case 'car': this.s.car = btn.getAttribute('data-car'); break;
        case 'nokit':
          if (this.kit) delete this.s.sel[this.kit.id];
          this.s.noKit = true;
          break;
        case 'kit':
          if (this.kitBuyable()) { this.s.sel[this.kit.id] = (this.selVariant(this.kit) || this.firstAvailable(this.kit)).id; this.s.noKit = false; }
          break;
        case 'wheel': this.pickOne(p, 'wheel'); this.autoAdapter(); break;
        case 'tire': this.pickOne(p, 'tire'); break;
        case 'toggle': this.toggle(p); break;
        case 'variant': this.setVariant(p, parseInt(btn.getAttribute('data-vid'), 10)); break;
        case 'adapter-off': if (this.adapter) delete this.s.sel[this.adapter.id]; this.s.adapterOff = true; break;
        case 'adapter-on':
          if (this.adapter && this.firstAvailable(this.adapter)) { this.s.sel[this.adapter.id] = this.firstAvailable(this.adapter).id; this.s.adapterOff = false; }
          break;
        case 'skip': {
          var key = btn.getAttribute('data-step-key');
          var self = this;
          this.selOf(key).forEach(function (x) { delete self.s.sel[x.id]; });
          if (!this.has(key)) { this.goTo(this.s.step + 1); return; }
          break;
        }
        case 'remove':
          if (p) {
            delete this.s.sel[p.id];
            if (p.kit) this.s.noKit = true;
            if (this.adapter && p.id === this.adapter.id) this.s.adapterOff = true;
          }
          break;
        case 'fsk': this.loadFullSend(false); this.render(true); return;
        case 'fsk-add': if (p) { var fv = this.firstAvailable(p); if (fv) this.s.sel[p.id] = fv.id; } break;
        case 'share': this.share(); return;
        case 'add': this.addToCart(btn); return;
        default: return;
      }
      this.applied = '';
      this.render(false);
    }
    goTo(i) {
      if (isNaN(i)) return;
      i = Math.max(0, Math.min(STEPS.length - 1, i));
      if (i === this.s.step) return;
      if (i > this.s.step) {
        var t = this.totals();
        publish('lbs:builder_step', { vehicle: this.d.vehicle, car: this.s.car, step: STEPS[this.s.step].key, step_index: this.s.step + 1, items: t.count, total: t.total / 100 });
      }
      this.s.step = i;
      this.render(true);
    }
    pickOne(p, step) {
      if (!p) return;
      var self = this;
      var already = !!this.s.sel[p.id];
      this.selOf(step).forEach(function (x) { delete self.s.sel[x.id]; });
      if (!already) {
        var v = this.firstAvailable(p);
        if (v) this.s.sel[p.id] = v.id;
      }
    }
    autoAdapter() {
      var a = this.adapter;
      if (!a || !this.has('wheel') || this.s.adapterOff || this.s.sel[a.id]) return;
      var v = this.firstAvailable(a);
      if (v) this.s.sel[a.id] = v.id;
    }
    toggle(p) {
      if (!p) return;
      var self = this;
      if (this.s.sel[p.id]) { delete this.s.sel[p.id]; return; }
      if (p.group) p.group.forEach(function (id) { delete self.s.sel[id]; });
      var v = this.firstAvailable(p);
      if (v) this.s.sel[p.id] = v.id;
    }
    setVariant(p, vid) {
      if (!p) return;
      var v = p.variants.filter(function (x) { return x.id === vid; })[0];
      if (!v || !v.available) return;
      var self = this;
      if (p.step === 'wheel' || p.step === 'tire') {
        this.selOf(p.step).forEach(function (x) { if (x.id !== p.id) delete self.s.sel[x.id]; });
      } else if (p.group && !this.s.sel[p.id]) {
        p.group.forEach(function (id) { delete self.s.sel[id]; });
      }
      this.s.sel[p.id] = v.id;
      if (p.kit) this.s.noKit = false;
      if (p.step === 'wheel') this.autoAdapter();
    }

    shareUrl() {
      var ids = this.lines().map(function (l) { return l.v.id; });
      var url;
      try { url = new URL(window.location.href); } catch (e) { return window.location.href; }
      url.hash = '';
      url.searchParams.set('build', ids.join(','));
      if (this.fskOn()) url.searchParams.set('kit', 'full-send'); else url.searchParams.delete('kit');
      if (this.s.car && this.cars.length > 1 && this.s.car !== this.cars[0].handle) url.searchParams.set('car', this.s.car);
      else url.searchParams.delete('car');
      return url.toString().replace(/%2C/gi, ',');
    }
    share() {
      var url = this.shareUrl(), self = this;
      function done(ok) {
        self.msg = ok ? '<p class="lbsb-msg__ok">Link copied. Send it to whoever\'s paying.</p>'
          : '<p>Copy this link: <input class="lbsb-msg__url" type="text" readonly value="' + esc(url) + '" aria-label="Share link" onclick="this.select()"></p>';
        var box = self.querySelector('[data-msg]');
        if (box) box.innerHTML = self.msg;
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
      } else done(false);
    }

    addToCart(btn) {
      if (this.busy) return;
      var self = this, t = this.totals();
      if (!t.count) { this.goTo(1); return; }
      if (this.s.step !== STEPS.length - 1) { this.s.step = STEPS.length - 1; }
      var buildId = shortId();
      var car = this.s.car || this.d.vehicle;
      var items = t.lines.map(function (l) {
        var props = { _build_id: buildId, _build_vehicle: car, _source: 'builder' };
        if (self.fskOn()) props._full_send_kit = self.fsk.key;
        return { id: l.v.id, quantity: l.q, properties: props };
      });
      var cartDrawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (cartDrawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      this.busy = true;
      this.msg = '';
      this.applied = '';
      this.render(false);
      fetch(this.d.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (json) { return { ok: res.ok, status: res.status, json: json }; });
        })
        .then(function (r) {
          if (!r.ok || r.json.status) {
            var m = (r.json && (r.json.description || r.json.message)) || 'Something went wrong adding your build.';
            if (typeof m === 'object') m = JSON.stringify(m);
            self.busy = false;
            self.msg = '<div class="lbsb-note lbsb-note--crit" role="alert"><strong>Couldn\'t add the build.</strong> ' + esc(m) +
              '<br>Your build is saved. If a part is sold out or low on stock, remove it and try again, or <a class="lbs-link" href="' + esc(self.t.help_url || '/pages/contact') + '">ask a build expert</a>.</div>';
            self.render(false);
            var box = self.querySelector('[data-msg]');
            if (box) box.setAttribute('tabindex', '-1'), box.focus({ preventScroll: false });
            return;
          }
          publish('lbs:builder_add', {
            vehicle: self.d.vehicle, car: car, build_id: buildId, items: t.count, total: t.total / 100,
            estimated_savings: t.savings / 100, kit: self.kitOn(), full_send: self.fskOn(), savings_kind: t.kind,
            variant_ids: t.lines.map(function (l) { return l.v.id; })
          });
          try {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lbs-builder', cartData: r.json });
            }
          } catch (e) { /* optional */ }
          self.busy = false;
          self.msg = '<p class="lbsb-msg__ok">Build added to your cart.</p>';
          self.render(false);
          var opened = false;
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && r.json.sections && r.json.sections['cart-drawer']) {
            try {
              cartDrawer.classList.remove('is-empty');
              if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(btn);
              cartDrawer.renderContents(r.json);
              opened = true;
            } catch (e) { console.error('[lbs-builder] drawer refresh failed', e); }
          }
          if (!opened) { window.location.href = self.d.cart_url || '/cart'; return; }
          return fetch(self.d.cart_js_url || '/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              if (cart && cart.total_discount > 0) {
                self.applied = (t.kind === 'fsk' ? 'Full Send Kit savings applied: ' : 'Build savings applied: ') + self.money(cart.total_discount, true);
                self.msg = '<p class="lbsb-msg__ok">Build added to your cart. ' + esc(self.applied) + '</p>';
                self.render(false);
              }
            })
            .catch(function () { /* savings line is optional */ });
        })
        .catch(function (err) {
          console.error('[lbs-builder]', err);
          self.busy = false;
          self.msg = '<div class="lbsb-note lbsb-note--crit" role="alert"><strong>Couldn\'t reach the cart.</strong> Check your connection and try again. Your build is saved.</div>';
          self.render(false);
        });
    }
  }

  customElements.define('lbs-builder', LbsBuilder);
})();
